import LocationAdapter from '@javascripts/adapters/location_adapter';

export default class PlayerStartAtTime {
  static startTime() {
    const value = LocationAdapter.search()['t'];

    return Number(value) || 0;
  }

  constructor({ tech }) {
    this._tech = tech;
  }

  init(time) {
    this._tech.currentTime(time);
  }
}
